import React, { useEffect, useState } from 'react'
import { Space, Typography, Image, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Button from 'antd-button-color'
import to from 'await-to-js'
import { toast } from 'react-toastify'
import ServiceAPI from '~services/services'
import Fuse from 'fuse.js'
import TitleBar from '~components/Elements/TitleBar'
import NumberWithCommas from '~utils/NumberWithCommas'
import Search from '~components/Elements/Search'

import AddReward from '~components/Rewards/Add'
import EditReward from '~components/Rewards/Edit'
import TableAntd from '~components/Elements/TableAntd'

const Rewards = () => {

    const [dataSource, setDataSource] = useState<any>([])
    const [dataRewards, setDataRewards] = useState<any>([])
    const [rewardUpdate, setRewardUpdate] = useState<any>([])

    const [filterText, setFilterText] = useState('')
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const [isAddOpen, setIsAddOpen] = useState<boolean>(false);
    const toggleModalAdd = () => setIsAddOpen(!isAddOpen)

    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
    const toggleModalEdit = () => setIsEditOpen(!isEditOpen)

    const getRewards = async () => {
        setIsLoading(true)
        setDataRewards([])
        const [err, res] = await to(ServiceAPI.getRewards())
        if (err) {
            toast.error(err?.message as string)
            setIsLoading(false)
        } else {
            setDataRewards(res.data)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        getRewards()
        return () => {
            setDataRewards([])
            setDataSource([])
        }
    }, [])

    const handleSearch = () => {
        if (Object.keys(dataRewards).length > 0) {
            const fuseSearch = new Fuse<any>(dataRewards, {
                keys: ['name', 'point'],
            })
            if (filterText !== '') {
                setDataSource(fuseSearch.search(filterText).map((x) => x.item))
            } else {
                setDataSource(dataRewards)
            }
        } else {
            setDataSource(dataRewards)
        }
    }


    const handleDelete = (id: number, name: string) => {
        Modal.confirm({
            title: `คุณต้องการลบ ${name}?`,
            icon: <ExclamationCircleOutlined />,
            content: 'เมื่อลบแล้วข้อมูลทั้งหมดจะถูกลบ และไม่สามารถกู้คืนได้',
            okText: 'ใช่',
            okType: 'danger',
            cancelText: 'ไม่',
            async onOk() {
                const [err, res] = await to(ServiceAPI.deleteRewards(id))
                if (err) {
                    toast.error(err.message as string)
                } else {
                    toast.success(res.message)
                    getRewards()
                }
            },
            onCancel() {

            },
        });
    }

    const columns = [
        {
            title: 'ชื่อของรางวัล',
            dataIndex: 'name',
            render: (text: any, record: any) => (
                <Space>
                    <Image
                        className='ant-img-circle'
                        width={32}
                        height={32}
                        alt={record.name}
                        src={record.image ? record.image : 'error'}
                        fallback="data:image/png;base64,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"
                    />
                    <Typography.Text strong>{record.name}</Typography.Text>
                </Space>
            )
        },
        {
            title: 'คะแนน',
            dataIndex: 'point',
            render: (text: any, record: any) => (
                <Typography.Text strong>{record.point}</Typography.Text>
            )
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            ellipsis: true,
            width: 140,
            align: 'center',
            render: (text: any, record: any) => (
                <Space size={1}>
                    <Button
                        type="warning"
                        size="small"
                        icon={<i className="fa-solid fa-edit me-2"></i>}
                        onClick={() => {
                            toggleModalEdit()
                            setRewardUpdate(record)
                        }}>
                        แก้ไข
                    </Button>
                    <Button
                        type="danger"
                        size="small"
                        icon={<i className="fa-solid fa-trash me-2"></i>}
                        onClick={() => { handleDelete(record.id, record.name) }}>
                        ลบ
                    </Button>
                </Space >
            )
        }
    ]


    useEffect(() => {
        handleSearch()
    }, [filterText, dataRewards]) // eslint-disable-line


    return (
        <>
            <TitleBar title="ของรางวัล" subTitle={`${NumberWithCommas(dataSource?.length || 0)} รายการ`} />
            <div className="d-flex justify-content-start mb-4">
                <Search onChangeSearch={setFilterText} filterText={filterText} />
            </div>
            <div className="row mb-md-3 align-items-md-center">
                <div className="mb-3 mb-md-0">
                    <Button
                        type="primary"
                        className="d-block ms-auto"
                        icon={<i className="fa-solid fa-plus me-3"></i>}
                        onClick={toggleModalAdd}>
                        เพิ่มของรางวัล
                    </Button>
                </div>
            </div>
            <div className="box-white ant-box-table">
                {/* <RewardCard
                    data={dataSource}
                    loading={isLoading}
                    handleEdit={handleEdit}
                    onloadData={getRewards}
                /> */}
                <TableAntd
                    columns={columns}
                    dataSource={dataSource || []}
                    loading={isLoading}
                />
            </div>
            {isAddOpen &&
                <AddReward
                    isOpen={isAddOpen}
                    close={() => toggleModalAdd()}
                    onloadData={getRewards}
                />
            }
            {isEditOpen &&
                <EditReward
                    isOpen={isEditOpen}
                    close={() => toggleModalEdit()}
                    onloadData={getRewards}
                    data={rewardUpdate}
                />
            }

        </>
    )
}

export default Rewards